import { render, staticRenderFns } from "./SimpleBanner.vue?vue&type=template&id=ce6a359c&scoped=true&"
import script from "./SimpleBanner.vue?vue&type=script&lang=js&"
export * from "./SimpleBanner.vue?vue&type=script&lang=js&"
import style0 from "./SimpleBanner.vue?vue&type=style&index=0&id=ce6a359c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce6a359c",
  null
  
)

export default component.exports